import React, { useState } from "react";
import { FaEllipsisV, FaTimes } from "react-icons/fa";

const ProfileDrawer = ({})=> {
    const [status, setStatus] = useState(true)
    const close = () => setStatus(false);
    const closeModal = (e) => {
        e.preventDefault()
        close(false);
      } 

    return status ? (
        <React.Fragment>
         <div className="profile-modal">
            <div className="profile-heading-light">
                <h4 className="title">Personal Infromation</h4>
                <FaTimes size={20} onClick={(e)=>closeModal(e)} />
            </div>
            <div className="img">
                {/***  <img src="/assets/img/image/images/1.png" /> */}
            </div>
            <div className="profile-detail">
                <div className="who">
                    <img src="/assets/images/faces/1.png" alt="" />
                    <div>
                        <h3 className="name">Adam Joe</h3>
                        <p className="slug">@adamjoe</p>
                    </div>
                </div>

                <div className="buttons">
                    <a href="##" className="button primary">Message</a>
                    <a href="##" className="button">Call</a>
                    <a href="##" className="button">
                        <FaEllipsisV />
                    </a>
                </div>
                
                <ul className="profile-detail-info">
                    <li>
                        <h4 className="title">Bio</h4>
                        <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eligendi sed id vel, quaerat non expedita
                        reiciendis explicabo repellendus numquam asperiores harum, consectetur quibusdam labore assumenda,
                        deleniti atque. Fuga, labore omnis.</p>
                    </li>

                    <li>
                        <h4 className="title">Location</h4>
                        <p>Washington, USA</p>
                    </li>
                    <li>
                        <h4 className="title">Website</h4>
                        <p>example.com</p>
                    </li>
                    <li>
                        <h4 className="title">Birth</h4>
                        <p>25 Ekim 1985</p>
                    </li>
                    
                </ul>
            </div>
        </div>
        <div 
            className="overlay"  
            onClick={(e)=>closeModal(e)}
        >
        </div>
    </React.Fragment>
        ) : <React.Fragment></React.Fragment>
}


export default ProfileDrawer;